import queries from "./combined";
import queriesMock from "./combined.mock";

const api = process.env.MOCK_API === "true" ? queriesMock : queries;

export default api;
